import React from "react";
import { useTranslation } from "react-i18next";
import Number from "./Number";

const Lunch = ({ totalCourses, categoryCount, usersCount }) => {
  const { t } = useTranslation();

  return (
    <div
      className="lg:my-s5 bg-gray-900 sm:my-16s"
      style={{ backgroundColor: "#334780" }}
    >
      <div className="relative overflow-hidden isolate py-10">
        <svg
          viewBox="0 0 1024 1024"
          className="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 translate-y-0 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0"
          aria-hidden="true"
        >
          <circle
            cx="512"
            cy="512"
            r="512"
            fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
            fillOpacity="0.7"
          ></circle>
          <defs>
            <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
              <stop stopColor="#14b8a6"></stop>
              <stop offset="1" stopColor="#0e7490"></stop>
            </radialGradient>
          </defs>
        </svg>

        <div className="mx-auto max-w-7xl px-2 sm:px-6 pt-8 mt-5">
          <div className="text-center md:text-start sm:text-lg md:text-2xl lg:text-3xl font-bold pb-16 mx-1 text-gray-200">
            {/* {t("afghanistan")} E-Learning System {t("app-name")} */}
            {t("e-learning-system-lunch-section")}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 mx-auto w-full gap-10 pb-16">
            {/* <div className='m-auto'>
                            <span className='font-bold text-3xl mb-2 text-gray-9 flex justify-center items-center text-orange-400'>
                                <Number n={813} /> +</span>
                            <h2 className='text-xl font-bold mt-1 text-center text-gray-200'>{t("educators")}</h2>
                        </div> */}
            <div className="m-auto">
              <span className="font-bold text-3xl mb-2 text-gray-9 flex justify-center items-center text-orange-400">
                <Number n={usersCount} /> +
              </span>
              <h2 className="text-xl font-bold mt-1 text-center text-gray-200">
                {t("students")}
              </h2>
            </div>
            <div className="m-auto">
              <span className="font-bold text-3xl mb-2 flex justify-center items-center text-orange-400">
                <Number n={totalCourses} /> +
              </span>
              <h2 className="text-xl font-bold mt-1  text-center text-gray-200">
                {t("courses-total")}
              </h2>
            </div>
            <div className="m-auto">
              <span className="font-bold text-3xl mb-2 flex justify-center items-center text-orange-400">
                <Number n={categoryCount} /> +
              </span>
              <h2 className="text-xl font-bold mt-1  text-center text-gray-200">
                {t("fields")}
              </h2>
            </div>
          </div>
          <p className="text-center font-bold text-xl mb-12 text-gray-200">
            {t("afg-serving")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Lunch;
